import { inject } from '@angular/core';
import { LoggingChannelPubSubService } from '../services/pubsub.service';
import { LogChannel } from '../constants/log-channel';
import { Subscription } from 'rxjs';
import { LoggingMessageInterface } from '../models/logging-data';

export abstract class BaseHandler<InitProperties, LoggingPropertyConfiguration> {
  protected pubsub = inject(LoggingChannelPubSubService);

  protected abstract readonly channelToSubscribe: LogChannel;
  protected subscription: Subscription | null = null;

  protected abstract messageHandler: (value: LoggingMessageInterface) => void;
  public abstract init(initProperties: InitProperties): void;
  public abstract createSetup(properties: LoggingPropertyConfiguration): void;

  protected createSubscription(): void {
    this.subscription = this.pubsub.of(this.channelToSubscribe, this.messageHandler);
  }
}
